import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Transition from 'react-transition-group/Transition';
import './Drawer.scss';

export default class Drawer extends Component {
  static propTypes = {
    open: PropTypes.bool,
    position: PropTypes.string,
    className: PropTypes.string,
    mobileFullHeight: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    closeBtnClass: PropTypes.string,
    contentClassName: PropTypes.string,
    onClose: PropTypes.func,
    backDrop: PropTypes.bool,
    showBackIcon: PropTypes.bool,
    isBackDropDismissable: PropTypes.bool,
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    open: false,
    position: 'right',
    className: '',
    mobileFullHeight: false,
    showCloseButton: true,
    closeBtnClass: '',
    contentClassName: '',
    onClose: null,
    backDrop: true,
    showBackIcon: false,
    isBackDropDismissable: true
  };

  dismissDrawer = () => {
    const { isBackDropDismissable, onClose } = this.props;
    if (isBackDropDismissable) {
      onClose();
    }
  };

  handleNodeMount = () => {
    document.body.classList.add('noScroll');
  };

  handleNodeUnmount = () => {
    document.body.classList.remove('noScroll');
  };

  render() {
    const {
      open,
      position,
      className,
      showBackIcon,
      showCloseButton,
      closeBtnClass,
      onClose,
      contentClassName,
      backDrop,
      children
    } = this.props;
    return (
      <Transition
        unmountOnExit
        mountOnEnter
        onExit={this.handleNodeUnmount}
        onEntered={this.handleNodeMount}
        in={open}
        timeout={150}
      >
        {
          (state) => (
            <div className={cx('drawer', className, state)}>
              {backDrop &&
                <div className="backdrop" onClick={this.dismissDrawer}>&nbsp;</div>
              }
              <div
                className={cx(
                  "drawerContent",
                  contentClassName,
                  position,
                )}
              >
                {
                  showCloseButton ? (
                    <div
                      className={cx(
                        "drawerClose",
                        closeBtnClass,
                      )}
                      onClick={onClose}
                    >
                      <img src={require('@images/cross_2.svg')} alt="x" />
                    </div>
                  ) : null
                }
                {children}
              </div>
            </div>
          )
        }
      </Transition>
    );
  }
}
